var __jsx = React.createElement;
import Waffles, { useKeyboardNavigation } from '@pelotoncycle/waffles';
import React from 'react';
import { useCopy } from '@webtv/copy-provider';
import { BASE_PATH, PELOTON_PLATFORM } from '@webtv/env';
import { GlobalStyles } from '@webtv/global-styles';
import { InternationalizeProvider } from '@webtv/internationalize';
import { PageStyles } from '@webtv/layout';
import { ErrorModal } from './ErrorModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var FatalError = function FatalError() {
  useKeyboardNavigation();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GlobalStyles, {}), /*#__PURE__*/_jsx(PageStyles, {}), /*#__PURE__*/_jsx(Waffles, {
      children: /*#__PURE__*/_jsx(InternationalizeProvider, {
        page: "error",
        pelotonPlatform: PELOTON_PLATFORM,
        children: /*#__PURE__*/_jsx(FatalErrorModal, {})
      })
    })]
  });
};

var FatalErrorModal = function FatalErrorModal() {
  var onClick = React.useCallback(function () {
    if (typeof window !== 'undefined') {
      window.location.href = BASE_PATH + '/';
    }
  }, []);
  var titleCopy = useCopy('error.loadingError');
  var mainCtaCopy = useCopy('error.tryAgain');
  return /*#__PURE__*/_jsx(ErrorModal, {
    titleCopy: titleCopy,
    mainCtaCopy: mainCtaCopy,
    mainCta: onClick
  });
};

export default FatalError;